import * as React from 'react'

import { Table, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

interface Props {
  participantFullName: string
  answers: Record<string, string | number>
  questionIds: Set<string>
  isAnonymous: boolean
}

const SurveyRow = ({ participantFullName, answers, questionIds, isAnonymous }: Props) => {
  const sortedAnswerValues = Array.from(questionIds).map((questionId) => answers[questionId])

  const NOT_ANSWERED = '-'

  return (
    <Table.Row>
      {!isAnonymous && (
        <Table.Cell>
          <Text.Normal>{participantFullName}</Text.Normal>
        </Table.Cell>
      )}
      {sortedAnswerValues.map((value, key) => (
        <Table.Cell key={key}>
          <Text.Normal htmlTag="p" whiteSpace="breakSpaces">
            {value ?? NOT_ANSWERED}
          </Text.Normal>
        </Table.Cell>
      ))}
    </Table.Row>
  )
}

export default observer(SurveyRow)
